export interface WallboxCertificate {
  id: string;
  domain?: string;
  issuedBy?: string;
  purpose: string;
  serialNumber: string;
  validFrom?: Date;
  validTo?: Date;
}
